/* eslint-disable */
export default {
  save: 'Save',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
